import { useCallback, useEffect, useRef, useState } from "react";
import appLogger from "../../infra/logger/appLogger";
import { useAppDispatch, useAppSelector } from "../hook";
import { getGroupchats } from "./groupchatSlice";
import { GroupchatFlow } from "./types";
const groupchatLogger = appLogger.withTag("GroupChat");
export default function useGroupchat() {
    const dispatch = useAppDispatch();
    const [groupchatsData, setGroupchatsData] = useState(null);
    const { loading, loadingType } = useAppSelector((state) => state.groupchat);
    const [groupchatError, setGroupchatError] = useState(null);
    const resetError = () => {
        setGroupchatError(null);
    };
    const mountedRef = useRef(false);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    const getGroupchatsData = useCallback(async (params) => {
        try {
            setGroupchatError(null);
            const result = await dispatch(getGroupchats(params)).unwrap();
            if (mountedRef.current) {
                setGroupchatsData(result.groupchats);
            }
            return { data: result.groupchats, lastKey: result.lastKey, error: null };
        }
        catch (error) {
            const apiError = typeof error === "string" ? { message: error, errorCode: undefined } : error;
            if (mountedRef.current) {
                setGroupchatError({
                    errorType: GroupchatFlow.GET_GROUPCHATS,
                    errorMessage: apiError.message || "Unknown error",
                    errorCode: apiError.errorCode,
                });
                setGroupchatsData(null);
            }
            groupchatLogger.error(`Error fetching groupchats: ${apiError.message}`, error);
            return { data: null, lastKey: undefined, error: apiError.message, errorPayload: error };
        }
    }, [dispatch]);
    return {
        groupchatsData,
        isLoading: loading,
        loadingType,
        errorType: groupchatError?.errorType || null,
        errorMessage: groupchatError?.errorMessage || null,
        errorCode: groupchatError?.errorCode || null,
        getGroupchatsData,
        resetError,
    };
}
